import React from 'react'
import ContentTermUse from 'modules/terms/ContentTermUse'

export default function UseTerms() {
  return (
    <ContentTermUse />
  )
}